declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fwaLayer: any;
  }
}

export interface ApplicationEvent {
  eventType: 'application';
  application: {
    type: 'click';
    elements: string[];
  };
}

const fwaLayer = window.fwaLayer;
const separator = '/';
const fallbackSeparator = '-';

function escapingSeparator(item: string): string {
  return item.replace(separator, fallbackSeparator);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function econdaClickEvent(stepName: string, stepArea: string, element: string, value: string) {
  if (fwaLayer) {
    const dataType = 'applications';
    const applicationName = "flow-rate calculation";
    const applicationStep = 1;
    const applicationEvent: ApplicationEvent = {
      eventType: 'application',
      application: {
        type: 'click',
        elements: [],
      },
    };
    const econdaString =
      `${dataType}${separator}${applicationName}${separator}${applicationStep}${separator}${stepName}${separator}${stepArea}${separator}${escapingSeparator(
        element,
      )}${separator}${escapingSeparator(value)}`.toLowerCase();
    applicationEvent.application.elements.push(econdaString);
    fwaLayer.sendChunks(applicationEvent);
  }
}
